import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getApp } from "firebase/app";

const FirebaseStayTwoWheel = () => {
  const location = useLocation();
  const app = getApp("ohyaFinanceFirebase");
  const analytics = getAnalytics(app);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (location.pathname === "/loan/two-wheel") {
      timeoutRef.current = window.setTimeout(() => {
        logEvent(analytics, "finance_loan_two_wheel_time_stay", {
          time_length: 10,
          page_location: "https://www.ohyafinance.com/loan/two-wheel",
        });
      }, 10000);
    }

    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [location.pathname]);

  return null;
};

export default FirebaseStayTwoWheel;
